import { ReduxWrapper } from "src/app/redux/app.state";
import { IConsentsPermissionsState } from "../../models/consents-permissions.model";

export const consentsPermissionsInitialState: ReduxWrapper<IConsentsPermissionsState | undefined> = {
	loadedOnce: false,
	loading: false,
	error: undefined,
	value: undefined
};
